<ng-container *transloco="let t;">
    <div class="data-field-list">
        <form [formGroup]="form" class="d-flex align-items-center justify-content-center">
            <div class="me-1 dragAndDropWrapper">
                <span [data-feather]="'dragAndDrop'" size="25" ></span>
            </div>
            <div class="data-field-column-lt">
                <textarea formControlName="content" 
                          class="form-control guideline-content-field" 
                          rows="2"
                          cols="60"
                          [ngClass]="{ 'is-invalid error': submitted && form.get('content').invalid }"
                          [placeholder]="t('Guideline list item placeholder text (edit playbook) - Enter Guideline content here')"></textarea>

                <ng-container
                        *ngTemplateOutlet="errorMessage; context: {
                                                                     submitted: submitted,
                                                                     formControl: form.get('content'),
                                                                     label:t('Guideline content field label (edit playbook) - Guideline content')
                                                                }"
                ></ng-container>
            </div>
            <div class="data-field-actionBtn ms-1">
                <span class="delete-icon" (click)="onRemoveGuidelineClicked()">
                    <i [data-feather]="'x'" [size]="14"></i>
                </span>
            </div>
        </form>
    </div>
</ng-container>

<ng-template #errorMessage let-formControl="formControl" let-label="label" let-submitted="submitted">
    <ng-container *transloco="let t;">
        <div *ngIf="submitted && formControl?.invalid" class="invalid-feedback" [ngClass]="{ 'is-invalid': formControl?.invalid }">
            <div *ngIf="formControl.hasError('required')">{{ t('Field required (form validation) - Field name is required', {
                fieldName: label
            }) }}</div>

            <div *ngIf="formControl.hasError('minlength')">
                {{ t('Minimal length (validation message) Minimal length is', {min: formControl.getError('minlength')?.requiredLength}) }}
            </div>
        </div>
    </ng-container>
</ng-template>